/**
 * Host based monitoring component
 * Allows configuration for hosts in each site to which the pop pings every x configures seconds
 * and creates events if no response was sent for y configured times
 */

mainApp.component('hostBasedMonitoring', {
    templateUrl: '/public/components/host-based-monitoring.component.html',
    bindings: {
        site: '=',
        deleteItems : '&'
    },
    controller: hostBasedMonitoringController
});

function hostBasedMonitoringController($scope, $state, GeneralUtilsService, $sce) {
    var $ctrl = this;
    $ctrl.tableDataModified = false;
    $ctrl.timeConstraints;
    getSourceIp();
    getMailingLists();

    //the model was changed and settings need to be reloaded
     $scope.$on('modelReloadedEvent', function (event, data) {
       reload();
    });

    function reload() {
         $ctrl.tableDataModified = new Date().getTime();
         getSourceIp();
         getMailingLists();

    }

  $scope.hostMonitoringConfig = {
          dataURL : function(){ return null;},
          pageSize: 5,
          noSearch: true,
          sortButton: false,
          hideCheckboxes: false,
          multiSelect: true,
          deselect: true,
          noAutoSelect: true,
          selectedItems:[],
          fields : [{'label':'','path':'item','template':'<host-monitoring-rule rule="item" last-index="tableConfig.getLastIndex()" mailing-lists=tableConfig.mailingLists></host-monitoring-rule>'}],
          alternativeHead: [
                      {'label': 'Description', 'path': '', noSort: true},
                      {"label":$sce.trustAsHtml("Destination <div class='more-info' data-toggle='tooltip' data-placement='bottom' title='The Destination IP address for the ICMP test. Note: The source IP address is set to' " + $ctrl.sourceIp + '><span class="glyphicon glyphicon-question-sign"></span></div>'), "labelType":"html","path":"", noSort: true},
                      {"label":$sce.trustAsHtml("Interval (Sec) <div class='more-info' data-toggle='tooltip' data-placement='bottom' title='The time (in seconds) between each ICMP test'><span class='glyphicon glyphicon-question-sign'></span></div>"), "labelType":"html","path":"", noSort: true},
                      {"label":$sce.trustAsHtml("Fault Threshold <div class='more-info' data-toggle='tooltip' data-placement='bottom' title='After this number of consecutive failed ICMP tests, this host is considered unreachable and an event is generated'><span class='glyphicon glyphicon-question-sign'></span></div>"), "labelType":"html","path":"", noSort: true},
                      {"label":"","path":"", noSort: true},
                      {"label": "","path":"", noSort: true},


          ],
          addAction : function(type) {
            var newRule = {id: GeneralUtilsService.getRandomId(), sourceIp: $ctrl.sourceIp.address, name:"", active: true , testInterval: 10, faultThreshold: 10};
            $ctrl.site.hostMonitoringRules.push(newRule);
            this.datamodified = new Date().getTime();
          },
          specialActions:[{
                      func: function(selectedItems, config) {
                          var itemsToDelete = [];

                              selectedItems.forEach(function(item) {
                                  for (var i = 0 ; i < $ctrl.site.hostMonitoringRules.length; i++) {
                                      var rule = $ctrl.site.hostMonitoringRules[i];
                                      if (item.id === rule.id) {
                                          $ctrl.site.hostMonitoringRules.splice(i, 1);
                                          if (item.id > 0) {
                                          itemsToDelete.push(rule);
                                              break;
                                           }
                                      }
                                  }
                          });
                          config.selectedItems.length = 0;
                          $ctrl.deleteItems({items: itemsToDelete, propertyName: 'hostMonitoringRules'});
                          this.datamodified = new Date().getTime();
                      },
                      icon: "delete",
                      tooltip: "Delete"}
                  ],
          parseData: function(){
              return $ctrl.site.hostMonitoringRules;
          },
          getLastIndex: function(){
              return $ctrl.site.hostMonitoringRules.length;
          },
          mailingLists: []
      }

      function getSourceIp(){
         //get first address of cato's reserved range of the account to show as source
         store.fetch({
                path: '/getCatoReservedRangeAddress?accountId=' + $state.params.accountId,
                success: function (data) {
                    $ctrl.sourceIp = data;
                    $scope.hostMonitoringConfig.alternativeHead[1] = {label: $sce.trustAsHtml('Destination <div class="more-info" style="display: inline-block" data-toggle="tooltip" data-placement="bottom" title="The destination host IP address for the ICMP test. Note: The source IP address is set to ' + $ctrl.sourceIp.address + '"><span class="glyphicon glyphicon-question-sign"></span></div>'), "labelType":"html","path":"", noSort: true}
                }
          });
      }

      function getMailingLists() {
        store.fetch({
            method: 'POST',
            data: {dateField:"",from:0,limit:-1},
            dataObj: 'dataConfig',
            path: '/getMailingLists?accountId=' + $state.params.accountId,
            success: function(data) {
                $scope.hostMonitoringConfig.mailingLists = [];
                data.items.forEach(function(item) { $scope.hostMonitoringConfig.mailingLists.push(item.name);});
                $scope.$digest();
            }
        });
      }
};
